import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';
import { debounceTime, filter, shareReplay, tap } from 'rxjs/operators';
import { AppCommonModule } from 'src/app/common.module';
import { DashboardViewComponent } from 'src/app/components/views/dashboard/view-dashboard.component';
import { NavigationService } from 'src/app/services/navigation.service';
import { PlusService } from 'src/app/services/plus.service';
import { SitesService } from 'src/app/services/sites.service';
import { WorkerTicketsService } from 'src/app/services/worker-tickets.service';

@Component({
  selector: 'app-stripe-cancel-page',
  templateUrl: './cancel.page.html',
  styleUrls: ['./cancel.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    CommonModule,
    DashboardViewComponent,
  ],
})
export class StripeCancelPage {
  private plusService = inject(PlusService);
  private route = inject(ActivatedRoute);
  private navigationService = inject(NavigationService);
  private sitesService = inject(SitesService);
  private workerTicketsService = inject(WorkerTicketsService);

  params$ = combineLatest([this.route.queryParams, this.sitesService.getActiveList()]).pipe(
    filter(([_, sites]) => sites?.length > 0),
    debounceTime(1000),
    tap(async ([params, sites]) => params['parent'] !== 'null' ? this.workerTicketsService.openRoomTicket(params['parent'], params['ticket']) : this.plusService.onNewTask(sites)),
    tap(async () => this.navigationService.navigateToHome()),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  home() {
    this.navigationService.navigateToHome();
  }
}
